import React, { useState, useEffect } from "react";
import cn from "classnames";
import logout from "./logout";
import getUserRole from "./getRole";
import getLinks from "./getLinks";
import logoutIcon from "../images/main/logout.svg";

const LeftMenuMobile = ({ baseUrl, currentUser, classbookUrl }) => {
  const { first_name, last_name, grade_tag, rtk_client, role } = currentUser;
  const { MAIN_LINKS, SUB_LINKS, BOTTOM_LINKS } = getLinks(
    baseUrl,
    classbookUrl
  );
  const [isMenuOpen, setOpenMenu] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.querySelector(".menu-modal__wrapper").style.overflow = "auto";
      return;
    }
    document.body.style.overflow = "unset";
  }, [isMenuOpen]);

  const handleClick = () => {
    setOpenMenu(!isMenuOpen);
  };

  const renderTopBlock = () => (
    <div className="menu__top-block-wr">
      <div className="menu__top-block">
        <div className="menu__user-info">
          <span className="menu__user-name">
            {first_name} {last_name}
          </span>
          <span className="menu__user-detals">
            {getUserRole(role)} / {grade_tag}
          </span>
        </div>
      </div>
      {rtk_client && <a href={`${baseUrl}payment`}>Пополнить счёт</a>}
    </div>
  );

  const renderLinks = (array, className) => (
    <div className={className}>
      {array.map((item) => (
        <a
          key={item.url}
          href={item.url}
          target={item.url.startsWith(baseUrl) ? "_self" : "_blank"}
        >
          {item.text}
        </a>
      ))}
    </div>
  );

  const renderModal = () => (
    <div
      className={cn("menu-modal", {
        active: isMenuOpen,
      })}
    >
      <div className="menu-modal__overlay">
        <div className="menu-modal__wrapper">
          <div className="menu-modal__container">
            <div className="menu-modal__middle-block">
              {renderTopBlock()}
              {renderLinks(MAIN_LINKS, "menu__main-links")}
              {renderLinks(SUB_LINKS, "menu__submenu")}
            </div>
            {renderLinks(BOTTOM_LINKS, "menu__bottom")}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <header className="header user-header">
        <div
          className={cn("header__menu-mobile", {
            "header__menu-open": isMenuOpen,
          })}
          onClick={handleClick}
        />
        <a href={`${baseUrl}myeducation`}>
          <div className="header__logo" />
        </a>
        <button className="user-header__logout" onClick={logout}>
          <span>Выйти</span>
          <img src={logoutIcon} alt="" />
        </button>
      </header>
      {renderModal()}
    </React.Fragment>
  );
};

export default LeftMenuMobile;



// WEBPACK FOOTER //
// ./app/frontend/components/LeftMenuMobile.js